import React from 'react'
import styled from 'styled-components'
import { styleUtils } from 'styles'

import { Text } from 'components/Text'

const Root = styled(Text).attrs({
  as: 'blockquote',
})`
  margin: 0;
  position: relative;
  background-color: ${({ theme }) =>
    styleUtils.colors.fade(theme.colors.primary, 0.04)};
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radii[2]};

  &:before {
    position: absolute;
    content: '';
    width: 0.25rem;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.primary};
  }

  & p {
    margin: 0;
  }
`

export const Quote = ({ children }) => (
  <Root padding={[5, 7, 7]} marginY={4}>
    {children}
  </Root>
)
